import React, { useState, useEffect, useCallback } from "react";
import { Typography, Table, Tag, Button, Modal } from "antd";
import moment from "moment";
import CancelledOrderFilter from "./filter/index";
import Pageloader from "../../components/loader/index";
import { dataKey, DevDummyPermissionHelper, userhasPermissionHelper } from "../../utils/Helpers";
import * as calcelledOrderActions from "../../redux/actions/cancelledOrder.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PERMISSION_CONSTANT } from "../../utils/constants/app";
const { Title } = Typography;

const pageName = "Cancelled Orders";

const CancelledOrder = (props) => {
  const [postData, setPostData] = useState(null);
  const [formModalOpen, setFormModalOpen] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (props?.pageFilter && props?.pageFilter?.storeIds !== undefined){
      dataRun(props.pageFilter)
    }
  }, [props.pageFilter])

  const showOTPModal = (code) => {
    Modal.info({
      title: `Cancel return otp code`,
      content: `You code is #${code}`,
      okText: 'Ok',
      // onOk: () => onAction(id, type),
    });
  };

  const dataRun = useCallback((value)=>{
    const [start, end] = (value?.date === null || value?.date === undefined) ? "" : value?.date;
    // console.log("value", value)
    const pageFilterData = {
      ...value,
      storeIds: value?.storeIds === undefined || value?.storeIds?.length === 0 ? undefined : value?.storeIds.toString(),
      startDate: start === undefined ? moment() : start.toISOString(),
      endDate: end === undefined ? moment() : end.toISOString(),
      status: value?.status === undefined || value?.status?.length === 0 ? undefined : value?.status.toString(),
      // startDate: start === undefined ? moment.unix(moment()) : start.subtract(19, "hours").toISOString(),
      // endDate: end === undefined ? moment.unix(moment()) : end.subtract(0, "hours").toISOString(),
    };
    delete pageFilterData["date"];
    props.calcelledOrderActions.listAction(pageFilterData); 
  },[props.pageFilter])

  useEffect(() => {
    if (props?.pageData){setPostData(dataKey(props?.pageData))}
  }, [props?.pageData]);


  const paginationChange = async (page, limit) => {
    const pageData = {
      ...props.pageFilter,
      page: page,
      limit: limit,
    };
    try {
      await props.calcelledOrderActions.filterAction(pageData);
    } catch {}
  };

  const columns = [
    {
      title: 'Order ID',
      dataIndex: '_id',
      render: (value) => (<a onClick={()=>window.open(`overview/${value}`)}>{`${value}`}</a>|| "-" )
    },
    {
      title: 'Rider',
      dataIndex: 'rider',
      render: (value) => {
        return value ? <>
        <span>{value?.fullName}</span><br/>
        <a onClick={()=>window.open(`rider/${value?._id}`)} >{value?.display_id}</a>
        <p>{value?.phoneNumber}</p></>:"-"
      }
    },
    {
      title: 'Mart',
      dataIndex: 'storeName',
      render: (value) => ( value || "-" )
    },
    {
      title: 'Order Value',
      dataIndex: 'order_detail',
      render: (value) => ( `Rs: ${value?.total_amount}` || "-" )
    },
    {
      title: 'Reason',
      dataIndex: 'status_delivery',
      render: (value) => ( value?.reason || "-" )
    },
    {
      title: 'Force Received',
      dataIndex: 'canceled_return_status',
      render: (value) => ( value?.isForce ? "Yes" : "No" )
    },
    {
      title: 'Marked By',
      dataIndex: 'canceled_return_status',
      render: (value) => ( value?.markedBy || "-" )
    },
    {
      title: 'Cancelled At',
      dataIndex: 'status_delivery',
      render: (value) => {
        return value?.createdAt ?
        <><span>{moment(value?.createdAt).format("DD MMMM, yyyy")}</span>
        <p>{moment(value?.createdAt).format("h:mm A")}</p></>:"-"
      }
    },
    {
      title: 'Charged To Rider At',
      dataIndex: 'charge_to_rider',
      render: (value) => {
        return value?.charge_to_rider_at ?
        <><span>{moment(value?.charge_to_rider_at).format("DD MMMM, yyyy")}</span>
        <p>{moment(value?.charge_to_rider_at).format("h:mm A")}</p></>:"-"
      }
    },
    {
      title: 'Given to mart',
      dataIndex: 'canceled_return_status',
      render: (value) => {
        return value?.slug === 'rider_handed_to_mart' || 
          value?.slug === 'mart_recieved_from_rider' || 
          value?.slug === 'pending_cancelation_otp' 
          ? 
          <Tag color="success">Yes</Tag> : <Tag color="warning">Pending</Tag>
      }
    },
    {
      title: 'Received by mart',
      dataIndex: 'canceled_return_status',
      render: (value) => {
        return value?.slug === 'mart_recieved_from_rider' ? (
          <Tag color="success">Yes</Tag>
        ) : value?.slug === 'pending_cancelation_otp' ? (
          <Tag color="warning">OTP Pending</Tag>
        ) : (
          <Tag color="warning">Pending</Tag>
        );
        // return value?.slug === 'mart_recieved_from_rider' ? <Tag color="success">Yes</Tag> : <Tag color="warning">Pending</Tag>
      }    
    },
    {
      title: 'Action',
      render: (value) => {
        return <div className="page-content-header">
          {
            value?.canceled_return_status_image?.return_order_image && 
              <Button onClick={()=>ViewImagenAction(value?._id)} >View Image</Button>
          }
          {
            value?.canceled_return_status?.slug === 'pending_cancelation_otp' ? 
              // userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_CANCELLED_ORDERS_DASHBOARD_RECEIVE) &&
                <Button onClick={() => showOTPModal(value?.canceled_return_status.otp)}>Show pending OTP</Button>
            :
            <>
              { userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_CANCELLED_ORDERS_DASHBOARD_RECEIVE) &&
                <Button disabled={value?.charge_to_rider?.charge_to_rider_status || value?.canceled_return_status?.slug === 'mart_recieved_from_rider'} onClick={()=>onAction(value?._id, 'return')}>{value?.canceled_return_status?.slug === 'mart_recieved_from_rider'? 'Received' : 'Receive'}</Button>
              }
              { userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_CANCELLED_ORDERS_DASHBOARD_FORCE_RECEIVE) && <Button disabled={value?.charge_to_rider?.charge_to_rider_status || value?.canceled_return_status?.slug === 'mart_recieved_from_rider'} onClick={()=>onAction(value?._id, 'force')}>{value?.canceled_return_status?.slug === 'mart_recieved_from_rider'? 'Force Received' : 'Force Receive'}</Button>}
            </>
          }
          
        </div> 
      }  
    },
  ]

  // Modal Start **********************
    const handleFormCancel = useCallback(()=> {
      setFormModalOpen({})
    }, [])
    const ViewImagenAction = async (value) => {
      const addData = {
        order_id: value,
      }
      const data = await props.calcelledOrderActions.ViewImageAction(addData);
      setSelectedImage(data.data.data);
      setOpen(true);
    }    
    
    const onAction = (value, type=null) => {
      if (type === 'return') {
        setFormModalOpen(()=>({
          modal: true,
          value: {
            "status": "mart_recieved_from_rider",
            "orderId": value
          },
          type: type,
        }))
      }
      if (type === 'force') {
        setFormModalOpen(()=>({
          modal: true,
          value: {
            "status": "mart_recieved_from_rider",
            "orderId": value
          },
          type: type,
        }))
      }
    };

    const onCreateAction = async (data) => {
      try {
        if (data?.type === 'return') {
          const addData = {
            ...data?.value,
          }
          await props.calcelledOrderActions.editAction(addData);
          dataRun(props.pageFilter)
          handleFormCancel();
        }
        if (data?.type === 'force') {
          const addData = {
            ...data?.value,
          }
          await props.calcelledOrderActions.editActionForce(addData);
          dataRun(props.pageFilter)
          handleFormCancel();
        }
      } catch (e) {}
    }
  // Modal End **********************

  return (<>
    <div className="page-content">
      <div className="page-content-header">
        <Title level={2}>{pageName}</Title>
        <div></div>
      </div>
      <CancelledOrderFilter/>
      <div className="p-content">
        {props?.pageLoader ? <Pageloader /> :
          <Table
            dataSource={postData}
            columns={columns}
            pagination={props?.pagePagination?.length !== 0 ?{
              total: props?.pagePagination?.totalCount,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
              pageSize: props?.pagePagination?.limit,
              defaultCurrent: props?.pagePagination?.currentPage,
              pageSizeOptions: ["10", "20", "30", "40", "50"],
              showSizeChanger: true,
              onChange: (page, pageSize) => {paginationChange(page, pageSize)},
            } : ""}
          />
        }
      </div>
    </div>
    <Modal
      className="custom-modal"
      title={`Cancelled Order ${formModalOpen['type']}`}
      visible={formModalOpen['modal']}
      okText={`Confirm ${formModalOpen['type']}`}
      confirmLoading={props.pageLoader}
      cancelText="Cancel"
      onCancel={()=>handleFormCancel()}
      onOk={()=>onCreateAction(formModalOpen)
        // () => {form.validateFields().then((values) => {
        //   form.resetFields();
        //   onCreateAction(values, formModalOpen);
        // }).catch((e) => {
        //   // console.log('Validate Failed:', e);
        // });
        // }
      }
    >
      Are you sure to perform this action ?
    </Modal>
    <Modal visible={open} onCancel={() => setOpen(false)} footer={null} centered >
      {selectedImage && (
        <>
          {/* <h3>{cancelledImages}</h3> */}
          <img
            src={selectedImage}
            alt=""
            style={{ width: "100%", borderRadius: 8 }}
          />
        </>
      )}
    </Modal>
  </>);
};

const mapStateToProps = (state) => {
  return {
    pageData: state.CancelledOrderReducer.initialData,
    pageLoader: state.CancelledOrderReducer.initialLoading,
    pagePagination: state.CancelledOrderReducer.initialPagination,
    pageFilter: state.CancelledOrderReducer.initialFilter,
    user: state.authReducer.user,
    permissions: state.PermissionReducer.permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    calcelledOrderActions: bindActionCreators(calcelledOrderActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CancelledOrder);